import Leads from "../../../jsx/components/Dashboard/Leads/leads";

const LeadsWrapper = () => {
  return <Leads />;
};

export default constore(LeadsWrapper);
